Woolman.Utils.prepareQueryParams();
Woolman.Collection = document.querySelector('[data-ajax-parent]');

/**
 * Generates search params from form data for filtering collection or search results.
 * @param {HTMLElement} formElement - Form element to turn into search params.
 * @returns
 */
const generateSearchParamsFromFormData = (formElement) => {
  const checkboxesToKeep = {};
  for (const element of formElement.elements) {
    const key = element.getAttribute('name');
    if (!key || !key.includes('filter')) continue;
    const value = element.value;
    const inputType = element.getAttribute('type');

    if (value === '') continue;

    if (inputType == 'number' && (element.hasAttribute('data-min') || element.hasAttribute('data-max'))) {
      if (!element.closest('price-range').hasAttribute('data-updated')) {
        continue;
      }
    }

    if (inputType == 'checkbox') {
      if (element.checked) {
        if (!checkboxesToKeep[key]) {
          checkboxesToKeep[key] = [value];
          continue;
        } else {
          checkboxesToKeep[key].push(value);
          continue;
        }
      }

      if (Shopify.queryParams[key] && !checkboxesToKeep[key]) {
        Shopify.queryParams[key] = undefined;
      }
      continue;
    } else {
      Shopify.queryParams[key] = value;
    }
  }

  if (Object.entries(checkboxesToKeep).length > 0) {
    for (const [key, value] of Object.entries(checkboxesToKeep)) {
      Shopify.queryParams[key] = value.join(',');
    }
  }

  return Shopify.queryParams;
};

/**
 * This function fetches fresh collection page via AJAX request to collection's url.
 * @param {Array} selectors - Array of HTML element selectors to update.
 */
const getCollectionAJAX = async (selectors) => {
  Shopify.queryParams.page = 1;
  if (selectors) {
    try {
      const url = location.pathname + '?' + getCollectionURL();
      const res = await fetch(url);
      const body = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(body, 'text/html');
      console.log(doc);

      for (const selector of selectors) {
        if (!document.querySelector(selector) || !doc.querySelector(selector)) continue;
        document.querySelector(selector).innerHTML = doc.querySelector(selector).innerHTML;
      }

      const historyStateUrl = location.pathname + '?' + getCollectionURL();
      window.history.replaceState('', '', historyStateUrl);
      Woolman.Collection.classList.remove('processing');

    } catch (err) {
      location.search = getCollectionURL();
    }
  } else {
    location.search = getCollectionURL();
  }
};

/**
 * Returns URL for current collection. Utilizes URL parameters to save user's filters, sorting and pagination.
 * @param {string} view - Template name to load with view attribute, e.g. 'ajax'
 * @returns
 */
const getCollectionURL = (view) => {
  Shopify.queryParams.view = view || undefined;
  const urlToReturn = new URLSearchParams(JSON.parse(JSON.stringify(Shopify.queryParams))).toString();
  return decodeURIComponent(urlToReturn);
};

class SortBySelect extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this.querySelector('select');
    this.selectors = {
      grid: '#product-grid-ajax',
      //facets: '#facets',
      //currentFacets: '#current-facets-ajax',
      pagination: '#pagination-ajax',
    };

    if (Shopify.queryParams['sort_by']) {
      this.el.value = Shopify.queryParams['sort_by'];
    }

    this.el.addEventListener('change', this.onSelectChange.bind(this));
  }

  async onSelectChange(event) {
    Woolman.Collection.classList.add('processing');
    Woolman.Utils.prepareQueryParams();
    const value = event.target.value;
    Shopify.queryParams.sort_by = value;
    getCollectionAJAX(Object.values(this.selectors));
  }
}

if (customElements.get('sort-by') === undefined) {
  customElements.define('sort-by', SortBySelect);
}

class FacetsForm extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this.querySelector('form');
    this.selectors = {
      grid: '#product-grid-ajax',
      //facetsMobi: '#facets-mobi',
      //facetsDesk: '#facets-desk',
      count: '#products-count-ajax',
      currentFacets: '#current-facets-ajax',
      pagination: '#pagination-ajax',
    };
    const inputs = this.el.querySelectorAll('input');
    inputs.forEach((input) => {
      input.addEventListener('change', debounce(this.onCheckboxChanged.bind(this), 150));
    });

    this.el.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  async onFormSubmit(event) {
    event.preventDefault();
    Woolman.Collection.classList.add('processing');
    Woolman.Utils.prepareQueryParams();
    generateSearchParamsFromFormData(this.el);

    Woolman.ModalsAndDrawers.closeModalOrDrawer(this.closest('[data-drawer]').getAttribute('id'));
    getCollectionAJAX(Object.values(this.selectors));
  }

  async onCheckboxChanged() {
    Woolman.Collection.classList.add('processing');
    generateSearchParamsFromFormData(this.el);
    getCollectionAJAX(Object.values(this.selectors));
  }
}

if (customElements.get('facets-form') === undefined) {
  customElements.define('facets-form', FacetsForm);
}

/**
 * Replaces Shopify.queryParams in place with the query of the given URL. Mutating instead of
 * reassigning keeps every existing reference to the object valid.
 * @param {string} url - URL whose query string becomes the new set of parameters.
 */
const setQueryParamsFromURL = (url) => {
  const parsed = new URL(url, window.location.origin);

  Object.keys(Shopify.queryParams).forEach((key) => delete Shopify.queryParams[key]);
  parsed.searchParams.forEach((value, key) => {
    Shopify.queryParams[key] = value;
  });
};

/**
 * Ticks the facet checkboxes to match Shopify.queryParams. The facet forms are deliberately left
 * out of the AJAX swap - replacing their markup would drop the listeners FacetsForm binds in its
 * constructor - so removing a filter from the active-filter row has to update them by hand.
 * Without this the checkbox would stay checked and the next interaction would re-apply the filter
 * the customer just removed.
 */
const syncFacetFormsToQueryParams = () => {
  document.querySelectorAll('facets-form form').forEach((form) => {
    for (const element of form.elements) {
      const key = element.getAttribute('name');
      if (!key || !key.includes('filter') || element.getAttribute('type') !== 'checkbox') continue;

      const activeValues = (Shopify.queryParams[key] || '').split(',');
      element.checked = activeValues.includes(element.value);
    }
  });
};

/**
 * Removing a single filter from the active-filter row used to be a plain link, i.e. a full page
 * load. Route it through the same AJAX path the checkboxes use.
 *
 * Delegated from the document because #current-facets-ajax replaces its own contents on every
 * update. Chips marked data-full-reload (the price range) keep the native navigation.
 */
document.addEventListener('click', (event) => {
  const chip = event.target.closest('[data-remove-single-filter]');
  if (!chip || chip.hasAttribute('data-full-reload') || !Woolman.Collection) return;

  const url = chip.getAttribute('href');
  if (!url) return;

  event.preventDefault();
  Woolman.Collection.classList.add('processing');
  setQueryParamsFromURL(url);
  syncFacetFormsToQueryParams();
  getCollectionAJAX([
    '#product-grid-ajax',
    '#products-count-ajax',
    '#current-facets-ajax',
    '#pagination-ajax',
  ]);
});
